import React from 'react';
import clsx from 'clsx';
import { CityImprovementTypes } from '@colonist/game-states';
import styles from './UIGameCityImprovementTrackerMetropolisTriangle.module.scss';
export function UIGameCityImprovementTrackerMetropolisTriangle({ cityImprovementType, className }) {
    const cityImprovementTypeText = CityImprovementTypes[cityImprovementType].toLowerCase();
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.triangleContainer, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.border
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.background, styles[cityImprovementTypeText])
    }));
}
